module.exports = __webpack_public_path__ + "img/intro_tips_gq.d425b0a6.png";